import React from "react";
import gif from "../assets/img/spin.gif";
import TR from "./FileTemplateComponent/TR";
import IB from "./FileTemplateComponent/IB";
import InvitationCard from "./invitationCard";
import HTA from "./FileTemplateComponent/HTA";
import ButtonComponent from "./ButtonComponent";
import TechScan from "./FileTemplateComponent/TechScan";
import TechBrief from "./FileTemplateComponent/TechBrief";
import { Modal, ProgressBar, Tabs, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";

const DashboardReviewModals = ({
  show,
  handleClose,
  divRef,
  review,
  show1,
  handleClose1,
  progress,
  showEditModal,
  handleCloseEdit,
  title,
  handleChange,
  review_type,
  reviewTypes,
  tentative_completion_date,
  is_followup,
  studyId,
  studyCheck,
  reviewList,
  handleSubmit,
  showEditInvitation,
  openNewInvitationModal,
  handleCloseInvitation,
  tabKey,
  initTabKey,
  invitations,
  deleteInvitation,
  showNewInvitationModal,
  handleCloseNewInvite,
  isLoading,
  name,
  text,
  handleChangeEmail,
  emailSuggestion,
  suggestionHandler,
  handleSubmitInvitation,
  showCofirmDelete,
  handleCloseCofirmDelete,
  handleDelete,
  handleChangeNewInvite,
  downloadAsDocx,
}) => {
  const userData = useSelector((state) => state.user.data.role.role);
  return (
    <>
      <Modal
        className="modal-xl abstract--modal modal-dialog-centered rounded"
        show={show}
        onHide={handleClose}
        keyboard={false}
        backdrop="static"
        style={{ height: "92vh", overflow: "hidden" }} // Ensures modal has fixed max height
      >
        <Modal.Header>
          <h4 className="mb-2">{/* Your title content */}</h4>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div onClick={downloadAsDocx} className="export-btn">
              <i className="bi bi-file-earmark-word"></i> Download
            </div>
            <button className="btn btn-danger" onClick={handleClose}>
              X
            </button>
          </div>
        </Modal.Header>

        <div
          id="docx"
          ref={divRef}
          className="modal-body"
          style={{ overflowY: "auto", height: "calc(100vh - 150px)" }}
        >
          {review === 2 ? (
            <HTA />
          ) : review === 3 ? (
            <TR />
          ) : review === 4 ? (
            <IB />
          ) : review === 6 ? (
            <TechBrief />
          ) : (
            <TechScan />
          )}
        </div>

        <Modal.Footer>
          <button className="btn btn-success footer-button">Finish</button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="modal-sm abstract--modal modal-dialog-centered "
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Body className="text-center">
          <h4>Waiting for download...</h4>
          <div className="progressBarData">
            <ProgressBar now={progress} />
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Review */}
      <Modal
        className="modal-lg modal-dialog-centered edit-review-modal overflow-hidden"
        show={showEditModal}
        onHide={handleClose}
      >
        <Modal.Header className="">
          <h2>Edit Review</h2>
          <button className="btn btn-danger" onClick={handleCloseEdit}>
            X
          </button>
        </Modal.Header>

        <div className="container">
          <div className="row p-2">
            <div className="card  py-4 px-4 edit-review-modal-card">
              <form action="">
                <div className="mb-3 row">
                  <label className="col-sm-4 col-form-label">Review Name</label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={title}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-sm-4 col-form-label">Review Type</label>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      value={review_type}
                      name="review_type"
                      onChange={(e) => handleChange(e)}
                    >
                      {reviewTypes &&
                        reviewTypes.map(({ id, description }, index) => {
                          return (
                            <option
                              key={index}
                              value={id}
                              {...(index === id ? "selected" : "")}
                            >
                              {description}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="col-sm-4 col-form-label">
                    Tentative Date to complete
                  </label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      type="date"
                      name="tentative_completion_date"
                      value={tentative_completion_date}
                      placeholder="DD/MM/YYYY"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="col-sm-4 col-form-label">
                    Update Previous Review
                  </label>
                  <div className="col-sm-8 custom--logo">
                    <div className="" onChange={handleChange}>
                      <input
                        class="form-check-input me-1"
                        type="radio"
                        checked={is_followup === "1"}
                        name="is_followup"
                        value="1"
                        id="inlineRadio1"
                      />
                      Yes
                      <input
                        class="form-check-input ms-3 me-1"
                        checked={is_followup === "0"}
                        type="radio"
                        name="is_followup"
                        value="0"
                        id="inlineRadio2"
                      />
                      No
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-sm-4 col-form-label">Review List</label>
                  <div className="col-sm-8">
                    {is_followup === "1" ? (
                      <select
                        class="form-select"
                        value={studyId}
                        onChange={studyCheck}
                      >
                        {reviewList &&
                          reviewList.sort((a, b) => (a.id < b.id ? 1 : -1)) &&
                          reviewList.map(({ title, id }, index) => {
                            return (
                              <option
                                value={id}
                                {...(index === studyId
                                  ? "selected"
                                  : "unSelected")}
                              >
                                {title}
                              </option>
                            );
                          })}
                      </select>
                    ) : (
                      <select className="form-select" disabled></select>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="text-end mt-3">
                      <ButtonComponent
                        text={"Update Review"}
                        handleSubmit={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      {/* Manage Invitation Modal */}
      <Modal
        className="modal-xl modal-lg  modal-dialog-centered edit-invitation-modal overflow-hidden"
        show={showEditInvitation}
        onHide={handleClose}
      >
        <Modal.Header className="">
          <h2>Manage Invitations</h2>
          <button
            className="btn btn-primary invite-new-user-btn"
            onClick={openNewInvitationModal}
          >
            Invite New Reviewer
          </button>
          <button className="btn btn-danger" onClick={handleCloseInvitation}>
            X
          </button>
        </Modal.Header>
        <div className="row edit-invitation-padding">
          <Tabs
            className="text-dark"
            activeKey={tabKey}
            onSelect={(e) => initTabKey(e)}
          >
            <Tab
              eventKey="one"
              title="Searching"
              className="modal--tab-buttons"
            >
              <InvitationCard
                invitations={invitations}
                reviewStage={1}
                tabKey={tabKey}
                deleteInvitation={deleteInvitation}
              />
            </Tab>
            <Tab
              eventKey="two"
              title="Abstract Screening"
              className="modal--tab-buttons"
            >
              <InvitationCard
                invitations={invitations}
                reviewStage={2}
                tabKey={tabKey}
                deleteInvitation={deleteInvitation}
              />
            </Tab>
            <Tab
              eventKey="three"
              title="Fulltext Screening"
              className="modal--tab-buttons"
            >
              <InvitationCard
                invitations={invitations}
                reviewStage={3}
                tabKey={tabKey}
                deleteInvitation={deleteInvitation}
              />
            </Tab>
            <Tab
              eventKey="four"
              title="Extraction"
              className="modal--tab-buttons"
            >
              <InvitationCard
                invitations={invitations}
                reviewStage={4}
                tabKey={tabKey}
                deleteInvitation={deleteInvitation}
              />
            </Tab>
          </Tabs>
        </div>
      </Modal>

      {/* New Invitation */}
      <Modal
        className="modal-md modal-dialog-centered edit-invitation-form overflow-hidden"
        show={showNewInvitationModal}
        onHide={handleClose}
      >
        <Modal.Header className="">
          <h4>New Invitation</h4>

          <button className="btn btn-danger" onClick={handleCloseNewInvite}>
            X
          </button>
        </Modal.Header>

        {isLoading ? (
          <div className="card d-flex justify-content-center align-items-center">
            <img src={gif} alt="" className="edit-new-reviewr-loader" />
          </div>
        ) : (
          <div className="card">
            {tabKey === "one" ? (
              <p className="text-center text-muted py-2">
                <strong>Invite Reviewer for Data Searching</strong>
              </p>
            ) : tabKey === "two" ? (
              <p className="text-center text-muted py-2">
                <strong>Invite Reviewer for Data Screening</strong>
              </p>
            ) : tabKey === "three" ? (
              <p className="text-center text-muted py-2">
                <strong>Invite Reviewer for Fulltext Screening</strong>
              </p>
            ) : tabKey === "four" ? (
              <p className="text-center text-muted py-2">
                <strong>Invite Reviewer for Data Extraction</strong>
              </p>
            ) : (
              ""
            )}
            <form action="" className="p-2">
              <div className="mb-3 row">
                <label className="col-sm-2 col-form-label">Name</label>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={name}
                    onChange={(e) => handleChangeNewInvite(e)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-sm-2 col-form-label">Email</label>
                <div className="col-sm-10">
                  <input
                    type="email"
                    className="form-control"
                    value={text}
                    onChange={handleChangeEmail}
                  />
                  {emailSuggestion && emailSuggestion.length > 0 && (
                    <div className="search--bar">
                      {emailSuggestion.map((item, index) => {
                        return (
                          <div className="p-2" key={index}>
                            <div
                              className="suggestion py-2"
                              onClick={() => suggestionHandler(item.email)}
                            >
                              {item.email}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="mb-3 row">
                <div className="col-sm-12">
                  <div className="text-end mt-3">
                    {!isLoading ? (
                      <button
                        className="new--add--button--review"
                        onClick={handleSubmitInvitation}
                      >
                        Invite User
                      </button>
                    ) : (
                      <button className="new--add--button--review" disabled>
                        Invite User
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
      </Modal>

      {/* Delete Invitation */}
      <Modal show={showCofirmDelete} onHide={handleCloseCofirmDelete}>
        <Modal.Header>
          <Modal.Title>Confirm Delete Invitation</Modal.Title>
          <button className="btn btn-danger" onClick={handleCloseCofirmDelete}>
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sur you want to delete Invitation ?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleCloseCofirmDelete}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={handleDelete}>
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DashboardReviewModals;
